/* eslint-env browser */
/*
 * Bootstrap transitions, optional include for modal fades etc.
 *
 * https://getbootstrap.com/docs/3.4/javascript/#transitions
 */
require('../bootstrap/js/transition');
